import React from "react";
import ChangePasswordForm from "../form/ChangePasswordForm";
import ManufacturerAccountForm from "../form/ManufacturerAccountForm";
import "./ManufacturerAccountModal.css";
import ModalWrapper from "components/common/modals/modalWrapper/ModalWrapper";

const ManufacturerAccountModal = ({
  onClose,
  isModalOpen,
  isUpdate = false,
  isChangePassword = false,
  selectedManufacturerAccount,
  fetchManufacturerAccounts,
}) => {
  return (
    <ModalWrapper
      show={isModalOpen}
      onClose={onClose}
      fullWidth
      maxWidth={isChangePassword ? "sm" : "md"}
      title={
        <>
          {!isChangePassword && (
            <span>{isUpdate ? "Update" : "Add"} Manufacturer Account</span>
          )}
          {isChangePassword && (
            <span>Change Manufacturer Account Password</span>
          )}
        </>
      }
    >
      <>
        {!isChangePassword && (
          <ManufacturerAccountForm
            handleClose={onClose}
            selectedManufacturerAccount={selectedManufacturerAccount}
            isUpdate={isUpdate}
          />
        )}

        {isChangePassword && (
          <ChangePasswordForm
            handleClose={onClose}
            selectedManufacturerAccount={selectedManufacturerAccount}
            fetchManufacturerAccounts={fetchManufacturerAccounts}
          />
        )}
      </>
    </ModalWrapper>
  );
};

export default ManufacturerAccountModal;
